import axios from "axios";
import { received } from "../DocumentationReducer";
import { baseURL } from "../thunks";

export const createFolderSubscription =
  ({ id }) =>
  async (dispatch) => {
    try {
      const postReq = await axios({
        method: "post",
        url: baseURL + "documentation/folders/" + id + "/subscription",
        data: {},
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      return postReq;
    } catch (error) {
      console.log(error);
      dispatch(received({ error: true }));
    }
  };
